import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Main from './views/Main.vue'


import enterprise from './views/nav/enterprise.vue'
import enterpriseMember from './views/nav/enterpriseMember.vue'
import enterpriseFile from './views/nav/enterpriseFile.vue'
import enterpriseGuest from './views/nav/enterpriseGuest.vue'
import enterpriseCar from './views/nav/enterpriseCar.vue'

import selfcheckPlan from './views/nav/selfcheckPlan.vue'
import selfcheckRecord from './views/nav/selfcheckRecord.vue'
import selfcheckReport from './views/nav/selfcheckReport.vue'
import enterpriseTrain from './views/nav/enterpriseTrain.vue'

//简化版 检查记录
import govCheckRecord from './views/nav/govCheckRecord.vue'
import govCheckCorrect from './views/nav/govCheckCorrect.vue'

import checkView from './views/nav/checkView.vue'
import checkCorrect from './views/nav/checkCorrect.vue'
import checkReview from './views/nav/checkReview.vue'
import checkRecord from './views/nav/checkRecord.vue'

import noticeManager from './views/nav/noticeManager.vue'

import safefileCheckForm from './views/nav/safefileCheckForm.vue'
import selfcheckForm from './views/nav/selfcheckForm.vue'
import checkForm from './views/nav/checkForm.vue'

import gwCheckItem from './views/nav/gwCheckItem.vue'
import accountManager from './views/nav/accountManager.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    },
    // { path: '/main', component: Main  ,name: '主页', hidden: true, children:null},
    {
        path: '/',
        component: Home,
        name: '基础管理',
        iconCls: 'fa fa-institution',//图标样式class
        children: [
            // 如果管局增加首页，需修改home文件，企业和管局的显示配置
            // { path: '/main', component: Main, name: '首页'},
            { path: '/enterprise', component: enterprise, name: '企业管理' },
            { path: '/enterpriseMember', component: enterpriseMember, name: '人员管理' },
            { path: '/enterpriseFile', component: enterpriseFile, name: '资料管理' },
            { path: '/enterpriseGuest', component: enterpriseGuest, name: '协议客户管理' },
            { path: '/enterpriseCar', component: enterpriseCar, name: '车辆管理' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '安全生产管理',
        iconCls: 'fa fa-server',//图标样式class
        children: [
            // { path: '/selfcheckPlan', component: selfcheckPlan, name: '隐患排查计划' },
            { path: '/selfcheckRecord', component: selfcheckRecord, name: '隐患排查记录' },
            { path: '/selfcheckReport', component: selfcheckReport, name: '重大隐患上报管理' },
            { path: '/enterpriseTrain', component: enterpriseTrain, name: '安全生产培训教育' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '监督检查',
        iconCls: 'fa fa-calendar-check-o',//图标样式class
        children: [
            // { path: '/checkView', component: checkView, name: '隐患审核' },
            // { path: '/checkCorrect', component: checkCorrect, name: '隐患整改' },
            // { path: '/checkReview', component: checkReview, name: '隐患复查' },
            // { path: '/checkRecord', component: checkRecord, name: '隐患记录' },
            { path: '/govCheckRecord', component: govCheckRecord, name: '检查记录' },
            { path: '/govCheckCorrect', component: govCheckCorrect, name: '整改情况' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '通知管理',
        iconCls: 'fa fa-newspaper-o',//图标样式class
        children: [
            { path: '/noticeManager', component: noticeManager, name: '企业通知管理' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '统计分析',
        iconCls: 'fa fa-list-alt',//图标样式class 
        children: [
            { path: '/safefileCheckForm', component: safefileCheckForm, name: '企业安全专项检查' },
            { path: '/selfcheckForm', component: selfcheckForm, name: '企业隐患排查统计' },
            // { path: '/checkForm', component: checkForm, name: '监督检查统计' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '系统管理',
        iconCls: 'fa fa-cogs',//图标样式class
        children: [
            // { path: '/gwCheckItem', component: gwCheckItem, name: '岗位排查栏目管理' },
            { path: '/accountManager', component: accountManager, name: '企业用户管理' },
        ]
    },
    
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js